import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ProposalNavigationPositionType, Scope } from "../../generated/apollo";
import { ClientConfig } from "../types/entities/ClientConfig";

interface ClientSettings {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;

  entityName: ClientConfig["entityName"];
  setEntityName: (entityName: ClientConfig["entityName"]) => void;

  insightPlaceholder: ClientConfig["insightPlaceholder"];
  setInsightPlaceholder: (
    insightPlaceholder: ClientConfig["insightPlaceholder"],
  ) => void;

  proposalNavigationPosition: ProposalNavigationPositionType | null;
  setProposalNavigationPosition: (
    proposalNavigationPosition: ProposalNavigationPositionType,
  ) => void;

  permissions: Record<string, Scope[]>;
  setPermissions: (permissions: Record<string, Scope[]>) => void;
}

export const useClientSettings = create<ClientSettings>()(
  devtools((set, _get) => ({
    isLoading: true,
    setIsLoading: (isLoading) => set({ isLoading }),

    entityName: {
      plural: "Proposals",
      singular: "Proposal",
    },
    setEntityName: (entityName) => set({ entityName }),

    insightPlaceholder: {
      singular: "Insight",
      plural: "Insights",
    },
    setInsightPlaceholder: (insightPlaceholder) => set({ insightPlaceholder }),

    proposalNavigationPosition: null,
    setProposalNavigationPosition: (proposalNavigationPosition) =>
      set({ proposalNavigationPosition }),

    permissions: {},
    setPermissions: (permissions) => set({ permissions }),
  })),
);

// Client Config Utils
export function getClientEntityName() {
  return useClientSettings.getState().entityName;
}

export function getClientInsightPlaceholder() {
  return useClientSettings.getState().insightPlaceholder;
}

export function getClientProposalNavigationPosition() {
  return useClientSettings.getState().proposalNavigationPosition;
}
